export default "<button class=\"button\" [type]=\"type\" [disabled]=\"disabled\">\r\n    {{name | uppercase}}\r\n</button>\r\n"